export default __webpack_public_path__ + "static/media/ju2.d256dd6e.jpg";